// extracted by mini-css-extract-plugin
export var tariffs__list = "tariffs-module--tariffs__list--zmQym";